/**
 * Header-based session ID fallback for cross-site deployments (e.g. shop.fitracking.com
 * talking to api.tryfi.com). Chrome blocks third-party cookies in this scenario, so the
 * fi.sid session cookie never reaches the API. The backend already supports an
 * x-session-id header as an alternative — this module stores the session ID returned
 * in auth responses and attaches it to subsequent requests.
 */

let sessionId: string | null = null;

export function getSessionId() {
  return sessionId;
}

export function setSessionId(id: string) {
  sessionId = id;
}

export function clearSessionId() {
  sessionId = null;
}

/** True when the frontend is served from a different domain than the API. */
export function isCrossSiteContext() {
  return !!process.env.REACT_APP_BASE_DOMAIN && process.env.REACT_APP_BASE_DOMAIN !== 'tryfi.com';
}
